
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice-per-popia",
      function () {
        return require("private-next-pages/notice-per-popia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notice-per-popia"])
      });
    }
  